import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const MESSAGES = [
  'Wir schauen uns dein Kuscheltier genau an …',
  'Wir gestalten die Buchfigur …',
  'Wir malen dein persönliches Cover …',
  'Wir setzen die erste Beispielseite …',
  'Gleich ist deine Vorschau fertig …',
];

export function Loading() {
  const nav = useNavigate();
  const [step, setStep] = useState(0);

  useEffect(() => {
    if (step >= MESSAGES.length) {
      const t = setTimeout(() => nav('/preview'), 600);
      return () => clearTimeout(t);
    }
    const t = setTimeout(() => setStep((s) => s + 1), 1100);
    return () => clearTimeout(t);
  }, [step, nav]);

  return (
    <div
      className="shell"
      style={{
        background: 'linear-gradient(180deg, var(--bg) 0%, var(--sand) 100%)',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          position: 'absolute',
          left: 30,
          top: 80,
          width: 8,
          height: 8,
          background: 'var(--sun)',
          clipPath:
            'polygon(50% 0,61% 35%,98% 35%,68% 57%,79% 91%,50% 70%,21% 91%,32% 57%,2% 35%,39% 35%)',
        }}
      />
      <div
        style={{
          position: 'absolute',
          right: 50,
          top: 140,
          width: 6,
          height: 6,
          background: 'var(--terracotta)',
          clipPath:
            'polygon(50% 0,61% 35%,98% 35%,68% 57%,79% 91%,50% 70%,21% 91%,32% 57%,2% 35%,39% 35%)',
        }}
      />
      <div
        style={{
          flex: 1,
          padding: '30px 24px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <div
          style={{
            width: 200,
            aspectRatio: '3/4',
            margin: '0 auto 32px',
            borderRadius: '6px 12px 12px 6px',
            background: 'linear-gradient(160deg, #DCE7EE 0%, #A8C0D2 100%)',
            boxShadow: '0 24px 40px -20px rgba(80,55,20,0.4)',
            position: 'relative',
            overflow: 'hidden',
          }}
        >
          <div
            style={{
              position: 'absolute',
              inset: 0,
              opacity: 0.3,
              background:
                'repeating-linear-gradient(0deg, transparent 0 18px, rgba(255,255,255,0.6) 18px 19px)',
              animation: 'scan 1.6s linear infinite',
            }}
          />
          <div
            style={{
              position: 'absolute',
              left: '50%',
              top: '40%',
              transform: 'translateX(-50%)',
              width: '55%',
              aspectRatio: '1',
              borderRadius: '50%',
              background: 'linear-gradient(160deg, #C8916A, #8E5B3E)',
            }}
          />
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 10,
            maxWidth: 360,
            width: '100%',
          }}
        >
          {MESSAGES.map((m, i) => {
            const done = i < step;
            const active = i === step;
            return (
              <div
                key={i}
                style={{
                  display: 'flex',
                  gap: 12,
                  alignItems: 'center',
                  fontSize: 14,
                  color: done ? 'var(--ink-soft)' : active ? 'var(--ink)' : 'var(--ink-mute)',
                  opacity: done ? 0.65 : 1,
                }}
              >
                <div
                  style={{
                    width: 18,
                    height: 18,
                    borderRadius: 999,
                    background: done
                      ? 'var(--sage-deep)'
                      : active
                        ? 'var(--terracotta)'
                        : 'transparent',
                    border: done || active ? 'none' : '1.5px solid var(--line)',
                    display: 'grid',
                    placeItems: 'center',
                    color: '#fff',
                    fontSize: 10,
                    flexShrink: 0,
                  }}
                >
                  {done ? '✓' : null}
                </div>
                <span style={{ fontWeight: active ? 600 : 400 }}>{m}</span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
